<template>
  <nav class="navbar navbar-expand-lg">
    <div class="container-fluid">
      <a class="navbar-brand" href="#/me">Dashboard</a>
      <button type="button"
              class="navbar-toggler navbar-toggler-right"
              :class="{toggled: $sidebar.showSidebar}"
              aria-controls="navigation-index"
              aria-expanded="false"
              aria-label="Toggle navigation"
              @click="toggleSidebar">
        <span class="navbar-toggler-bar burger-lines"></span>
        <span class="navbar-toggler-bar burger-lines"></span>
        <span class="navbar-toggler-bar burger-lines"></span>
      </button>
      <div class="collapse navbar-collapse justify-content-end">
        <ul class="nav navbar-nav mr-auto">
          <base-dropdown tag="li">
            <template slot="title">
              <i class="nc-icon nc-email"></i>
              <b class="caret"></b>
              <!-- <span class="notification">0</span> -->
            </template>
            <!-- <a class="dropdown-item" href="#">Notification 1</a>
            <a class="dropdown-item" href="#">Notification 2</a>
            <a class="dropdown-item" href="#">Notification 3</a>
            <a class="dropdown-item" href="#">Notification 4</a>
            <a class="dropdown-item" href="#">Another notification</a> -->
          </base-dropdown>
        </ul>
        <ul class="navbar-nav ml-auto">
          <base-dropdown :title="user.firstName">
            <router-link class="dropdown-item" to="/me/profile">Profile</router-link>
            <!-- <a class="dropdown-item" href="#/me/finance">Finance</a>
            <a class="dropdown-item" href="#/me/paymethods">Pay Methods</a> -->
            <a class="dropdown-item" v-if="hasEmulation" @click.prevent="authRelease" href="#">End Emulation</a>
            <div class="divider"></div>
            <a class="dropdown-item" @click.prevent="logout" href="#">Logout</a>
          </base-dropdown>
        </ul>
      </div>
    </div>
  </nav>
</template>
<script>
  export default {
    computed: {
      routeName () {
        const {name} = this.$route
        return this.capitalizeFirstLetter(name)
      },
      hasEmulation () {
        let tokenPayload = this.$store.getters.tokenPayload()
        return 'eid' in tokenPayload
      }
    },
    data () {
      return {
        activeNotifications: false,
        user: this.$store.state.users.profile
      }
    },
    methods: {
      capitalizeFirstLetter (string) {
        return string.charAt(0).toUpperCase() + string.slice(1)
      },
      toggleNotificationDropDown () {
        this.activeNotifications = !this.activeNotifications
      },
      closeDropDown () {
        this.activeNotifications = false
      },
      toggleSidebar () {
        this.$sidebar.displaySidebar(!this.$sidebar.showSidebar)
      },
      hideSidebar () {
        this.$sidebar.displaySidebar(false)
      },
      logout () {
        this.$store.dispatch('authLogout')
      },
      authRelease () {
        this.$store.dispatch('authEmulate', { action: 'release' })
      }
    }
  }

</script>
<style>

</style>
